import React from 'react'
import { Col, Alert } from 'reactstrap'
import { findNoCompletionsAlertNeeded } from '../../../helpers/assessment/assessmentDashboard';

export default function NoDataAlert ({
  role,
  scoring,
  notInitializing, 
  selectedStudent, 
  userAssessment,
  groupUA,
}) {
  const needAlert = findNoCompletionsAlertNeeded(
    role,
    scoring,
    notInitializing, 
    selectedStudent, 
    userAssessment,
    groupUA,
  )
 
  let groupText = ''
  if (needAlert === 'Student') groupText = 'This student has not'
  if (needAlert === 'Group') groupText = 'No selected students have'
  if (needAlert) {
    return (
      <Col xs='12' xl='12'>
        <Alert color='warning'>
          {`${groupText} taken this test, yet.`}
        </Alert>
      </Col>
    )
  } else return null
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessDash/NoDataAlert.js